/**
 * Exported function to register the template
 * 
 * @param {PopupRenderer} renderer static PopupRenderer class
 * 
 * @memberof vef.map.popup.templates
 */
export function opusLayer(renderer) {
    renderer.registerTemplate('opus', `
| {setTitle(properties.recorderDatasetName)} | |
|--|--|
| Provider | {properties.affiliation} |
| Period | {substring(properties.analysisStartDatetime, "0", "7")} - {substring(properties.analysisEndDatetime, "0", "7")} |
| Quality Data (Days) | {properties.opusProcessedDays} |
| Data quality flag | {properties.dataQuality} |
| DOI | {properties.doi} |
`);

renderer.registerTemplate('opus_portal', `
| {setTitle(properties.recorderDatasetName)} | |
|--|--|
| Provider | {properties.affiliation} |
| Period | {substring(properties.analysisStartDatetime, "0", "7")} - {substring(properties.analysisEndDatetime, "0", "7")} |
| Quality Data (Days) | {properties.opusProcessedDays} |
| Data quality flag | {properties.dataQuality} |
| DOI | {properties.doi} |

[Open Spectrogram Viewer](https://opus.aq/portal/recorder/{properties.recorderDatasetName})
`);
}
